import {ChangeDetectorRef, Component, Inject, Input, OnDestroy} from '@angular/core';
import {LearnAuthService} from '../../../core/authentication/learn-auth.service';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {map, switchMap} from 'rxjs/operators';
import {NavigationService} from '../../../core/navigation.service';
import {AuthUntilUserRoleService} from '../../../core/authentication/auth-until-user-role.service';
import {DialogViewModelCreatorService} from 'botato-angular-lib';
import {LoggerRessource} from '../../../../../../micromate-learn-lib/src/lib/services/rest/logger-ressource.service';
import {User} from '../../../../../../micromate-learn-lib/src/lib/components/chatbot/User';
import {LIB_AUTH_SERVICE_TOKEN} from '../../../../../../micromate-learn-lib/src/lib/components/chatbot/libAuthService';
import {BrandingService} from '../../../../../../micromate-learn-lib/src/lib/services/branding/branding.service';
import {ChatNewMessageIndicatorService} from '../../../../../../micromate-learn-lib/src/lib/services/ChatNewMessageIndicatorService';

@Component({
    selector: 'mm-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnDestroy {
    @Input() activeNavigation: 'chat' | 'badges' | 'scoreboard' | 'study-progress' | undefined;
    public isAuthenticated: boolean = false;
    public learnerId: string | undefined;

    public navigationOpen = false;
    public authServiceSubscription: Subscription;
    private getDialogViewModelSubscription: Subscription;

    constructor(@Inject(LIB_AUTH_SERVICE_TOKEN) public authService: LearnAuthService,
                private activatedRoute: ActivatedRoute,
                private translate: TranslateService,
                private logger: LoggerRessource,
                private titleService: Title,
                public navigationService: NavigationService,
                public authUntilUserRoleService: AuthUntilUserRoleService,
                private dialogViewModelCreatorService: DialogViewModelCreatorService,
                public brandingService: BrandingService,
                public chatNewMessageIndicatorService: ChatNewMessageIndicatorService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.titleService.setTitle('Micromate Learn');
        this.authServiceSubscription = this.activatedRoute.queryParamMap.pipe(
            map(params => {
                this.learnerId = params.get('learnerid') ?? undefined;
            }),
            switchMap(() => this.authService.authentication$))
            .subscribe((authentication: User | undefined) => {
                this.isAuthenticated = authentication !== undefined;
                const userLanguage = authentication?.uiLocale;
                if (userLanguage !== undefined && userLanguage.trim() !== this.translate.getCurrentLang()) {
                    this.translate.use(userLanguage.trim());
                }
                this.changeDetectorRef.markForCheck();
            });

        this.getDialogViewModelSubscription = this.authService.authentication$.subscribe(authentication => {
            if (authentication !== undefined && !this.navigationService.getActiveNavigation()) {
                this.navigationService.setActiveNavigation(true);
            }
        })
    }

    public logout(): void {
        this.logger.logFrontendInfoToBackend(`Call logout manually by user on ${window.location.href}`);
        this.authService.removeSelectedUser();
        this.authService.startLogoutFlow();
    }

    public getLernerIdParam(): { learnerid: string; } | undefined {
        if (this.learnerId === undefined) {
            return undefined;
        }
        return {learnerid: this.learnerId};
    }

    public getLernerIdParamForTabs(): { openInConversation: 'true' | 'false'; learnerid?: string; } {
        const params: { openInConversation: 'true' | 'false'; learnerid?: string; } = {openInConversation: 'false'};
        if (this.learnerId === undefined) {
            return params;
        }
        params.learnerid = this.learnerId;
        return params;
    }

    public ngOnDestroy(): void {
        if (this.authServiceSubscription !== undefined) {
            this.authServiceSubscription.unsubscribe();
        }

        if (this.getDialogViewModelSubscription !== undefined) {
            this.getDialogViewModelSubscription.unsubscribe();
        }
    }

}
